<template>
	<article class="cpf">
		<div class="cpf-top">
			<div class="cpf-image-container">
				<figure class="cpf-image" :class="{'xxx': xxxVisibility == true}">
					<NuxtLink :to="item.url_without_domain" @click="gtmSelectItem(item);">
						<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width240-height240']" default="/images/no-image-120.webp" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : item.title" />
					</NuxtLink>
					<div v-if="xxxVisibility == true" class="cpf-xxx-img-info"><BaseCmsLabel code="xxx_img_info" /></div>
				</figure>

				<template v-if="item.badges_special_1">
					<template v-for="badge in item.badges_special_1" :key="badge.code">
						<div v-if="badge.category == 0 && priceRecommended == false" class="cpf-badge cpf-badge-discount" :class="{'cpf-badge-discount-loyalty': isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom}">
							<span>
								<template v-if="item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom">{{ labels.get('loaylty') }}</template>
								-{{ discountPercent }} %
							</span>
							<div class="cpf-badge-tooltip cpf-badge-tooltip-discount">
								{{ labels.get('prihranek') }} <strong>{{ formatCurrency(priceSaved) }}</strong>
							</div>
						</div>
						<div v-else-if="badge.category == 4" class="cpf-badge cpf-badge-new">
							<span>{{ labels.get('new_badge') }}</span>
						</div>
					</template>
				</template>

				<div v-if="energyAttr" class="cpf-energy">
					<BaseUiImage v-if="energyAttr.image_upload_path" loading="lazy" :src="energyAttr.image_upload_path" default="/images/no-image-240.webp" width="80" height="25" :title="energyAttr.title" :alt="energyAttr.title" />
					<span v-else>energyAttr.title</span>
				</div>
			</div>

			<div class="clear cpf-cnt">
				<div class="cpf-info">
					<div class="cpf-code" v-if="item.code">{{ item.code }}</div>
					<div v-if="mode != 'menu'" class="cpf-category" :class="{'blur': xxxVisibility == true}">
						<NuxtLink :to="item.category_url_without_domain">{{ item.category_title }}</NuxtLink>
					</div>
					<h2 class="cpf-title" :class="{'blur': xxxVisibility == true}">
						<NuxtLink :to="item.url_without_domain" @click="gtmSelectItem(item);">
							{{ item.title }}
						</NuxtLink>
					</h2>
					<ClientOnly>
						<BaseFeedbackRatesWidget v-if="item?.feedback_rate_widget && item?.feedback_rate_widget?.rates_votes > 0" :data="item.feedback_rate_widget" v-slot="{stars}">
							<div class="cpf-cnt-comment">
								<span class="cp-rate rates-container" v-html="stars" />
								<div class="cpf-comment-count comments-count catalog-comment-count">
									<span>({{ item.feedback_comment_widget.comments }})</span>
								</div>
							</div>
						</BaseFeedbackRatesWidget>
					</ClientOnly>
				</div>

				<ClientOnly>
					<div v-if="item.price_custom > 0" class="cpf-price" :class="{'uau-badge': item.selected_price && item.selected_price == 'uau'}">
						<template v-if="priceRecommended == true">
							<div class="cpf-current-price red">{{ formatCurrency(item.price_custom) }}</div>
							<div v-if="item.loyalty_price_custom" class="cpf-old-price">{{ formatCurrency(item.basic_price_custom) }}</div>
						</template>
						<template v-else-if="(item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && ((!item.loyalty_price_custom || isLoyalty == true) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
							<span v-if="priceFrom" class="cpf-old-price cpf-price-label var">{{ labels.get('price_variation') }}</span>
							<div class="cpf-current-price cpf-discount-price red">{{ formatCurrency(item.price_custom) }}</div>
							<div v-if="!item.loyalty_price_custom || (isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom > item.price_custom)" class="cpf-old-price line-through">{{ formatCurrency(item.basic_price_custom) }}</div>
						</template>
						<template v-else-if="isLoyalty == true && item.loyalty_price_custom && item.price_custom > item.loyalty_price_custom">
							<span v-if="priceFrom" class="cpf-old-price cpf-price-label var">{{ labels.get('price_variation') }}</span>
							<div class="cpf-current-price cpf-discount-price blue">{{ formatCurrency(item.loyalty_price_custom) }}</div>
							<div class="cpf-old-price line-through">
								<template v-if="item.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)">{{ formatCurrency(item.price_custom) }}</template>
								<template v-else>{{ formatCurrency(item.basic_price_custom) }}</template>
							</div>
						</template>
						<template v-else>
							<div class="cpf-current-price">{{ formatCurrency(item.price_custom) }}</div>
						</template>

						<div v-if="isLoyalty == false && item.loyalty_price_custom && item.loyalty_price_custom < item.basic_price_custom" class="cp-loyalty-price-container">
							<div class="cpf-loyalty-price">
								<span>{{ formatCurrency(item.loyalty_price_custom) }}</span>
							</div>
						</div>
					</div>

					<div v-if="mobileBreakpoint.value && mode != 'menu' && mode != 'publish'" class="cpf-available-qty">
						<div v-if="item.availability_info" class="available-qty-btn">
							<template v-if="item.availability_info.status == 1">
								<span v-if="(item.last_piece_sale != 0 && item.last_piece_sale) && item.warehouses_single_pickup_display" class="available-last" v-html="labels.get('odprodaja')"></span>
								<span v-else-if="item.last_piece_sale != 0 && item.last_piece_sale" v-html="labels.get('odprodaja_2')" class="available-last"></span>
								<span v-else v-html="labels.get('na_zalogi')"></span>
							</template>
							<template v-else-if="item.availability_info.status == 2">
								<span v-html="labels.get('na_zalogi_dobavitelja').replace('%MIN_DAY%', item.availability_info.min_days).replace('%MAX_DAY%', item.availability_info.max_days)"></span>
							</template>
							<template v-else-if="item.availability_info.status == 4">
								<span class="available-last" v-html="labels.get('na_zalogi_ena')"></span>
							</template>
							<template v-else-if="item.availability_info.status == 5">
								<span v-if="item.is_available" v-html="labels.get('na_voljo') + ' ' + formatDate(item.shipping_date)"></span>
								<span v-else class="unavailable" v-html="labels.get('ni_na_zalogi_preorder')"></span>
							</template>
							<template v-else-if="item.availability_info.status == 7">
								<span class="unavailable" v-html="labels.get('ni_na_zalogi')"></span>
							</template>
							<template v-else-if="item.availability_info.status == 9">
								<span class="unavailable" v-html="labels.get('dalj_ni_na_zalogi')"></span>
							</template>
						</div>

						<template v-if="labels.get('iznenaci_ceno') != 'iznenaci_ceno' && item.extra_price_cart_dynamicprice > 0 && parseFloat(item.extra_price_dynamicprice) && 'extra_price_mode_dynamicprice'">{{ labels.get('iznenaci_ceno') }}</template>
					</div>
				</ClientOnly>
			</div>

			<div v-if="mode == 'publish'" class="cpf-btns">
				<ClientOnly>
					<CatalogWidgetSetCompare :item="item" />

					<BaseWebshopAddToCart v-slot="{onAddToCart, loading, addInProgress}" v-if="item.is_available" @addedToCart="addedToCart" :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: 1}">
						<div v-if="creation == true" class="btn btn-green cpf-btn-addtocart" :class="{'loading': loading, 'disabled': addInProgress}" @click="flyoutOrderInProgressInfo()">
							<span v-if="['advanced', 'configurable'].includes(item.type)">{{ labels.get('add_to_shopping_cart_configurable') }}</span>
							<span v-else-if="item.status == 5">{{ labels.get('add_to_shopping_cart_preorder') }}</span>
							<span v-else>{{ labels.get('add_to_shopping_cart') }}</span>
						</div>
						<div v-else class="btn btn-green cpf-btn-addtocart" :class="{'loading': loading, 'disabled': addInProgress}" @click="onAddToCart">
							<span v-if="['advanced', 'configurable'].includes(item.type)">{{ labels.get('add_to_shopping_cart_configurable') }}</span>
							<span v-else-if="item.status == 5">{{ labels.get('add_to_shopping_cart_preorder') }}</span>
							<span v-else>{{ labels.get('add_to_shopping_cart') }}</span>
						</div>
					</BaseWebshopAddToCart>
				</ClientOnly>
				<NuxtLink v-if="!item.is_available" :to="item.url_without_domain" class="btn btn-green cpf-btn-addtocart cpf-btn-details" @click="gtmSelectItem(item);">
					<span>{{ labels.get('read_more') }}</span>
				</NuxtLink>
			</div>
		</div>

		<div v-if="!mobileBreakpoint.value && mode != 'menu' && mode != 'publish'" class="cpf-bottom">
			<div class="cpf-available-qty">
				<ClientOnly>
					<div v-if="item.availability_info" class="available-qty-btn">
						<template v-if="item.availability_info.status == 1">
							<span v-if="(item.last_piece_sale != 0 && item.last_piece_sale) && item.warehouses_single_pickup_display" class="available-last" v-html="labels.get('odprodaja')"></span>
							<span v-else-if="item.last_piece_sale != 0 && item.last_piece_sale" v-html="labels.get('odprodaja_2')" class="available-last"></span>
							<span v-else v-html="labels.get('na_zalogi')"></span>
						</template>
						<template v-else-if="item.availability_info.status == 2">
							<span v-html="labels.get('na_zalogi_dobavitelja').replace('%MIN_DAY%', item.availability_info.min_days).replace('%MAX_DAY%', item.availability_info.max_days)"></span>
						</template>
						<template v-else-if="item.availability_info.status == 4">
							<span class="available-last" v-html="labels.get('na_zalogi_ena')"></span>
						</template>
						<template v-else-if="item.availability_info.status == 5">
							<span v-if="item.is_available" v-html="labels.get('na_voljo') + ' ' + formatDate(item.shipping_date)"></span>
							<span v-else class="unavailable" v-html="labels.get('ni_na_zalogi_preorder')"></span>
						</template>
						<template v-else-if="item.availability_info.status == 7">
							<span class="unavailable" v-html="labels.get('ni_na_zalogi')"></span>
						</template>
						<template v-else-if="item.availability_info.status == 9">
							<span class="unavailable" v-html="labels.get('dalj_ni_na_zalogi')"></span>
						</template>
					</div>

					<template v-if="labels.get('iznenaci_ceno') != 'iznenaci_ceno' && item.extra_price_cart_dynamicprice > 0 && parseFloat(item.extra_price_dynamicprice) && 'extra_price_mode_dynamicprice'">{{ labels.get('iznenaci_ceno') }}</template>
				</ClientOnly>
			</div>

			<div v-if="item.seller_id" class="cpf-seller">
				<span v-if="item.seller_title"
					>{{ labels.get('seller_item_title') }} <NuxtLink :to="item.seller_url_without_domain">{{ item.seller_title }}</NuxtLink></span
				>
			</div>
		</div>
	</article>
</template>

<script setup>
	const labels = useLabels();
	const auth = useAuth();
	const props = defineProps(['item', 'mode', 'categoryListData', 'index']);
	const {formatDate} = useText();
	const {formatCurrency} = useCurrency();
	const gtm = useGtmBB();
	const { creation } = useCheckout();
	const {bus, emit} = useEventBus();
	const webshop = useWebshop();

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});

	let loyaltyMinPrice = computed(() => {
		if (props.item.installments_calculation && props.item.installments_calculation.loyalty && Object.keys(props.item.installments_calculation.loyalty).length > 0) {
			const values = Object.values(props.item.installments_calculation.loyalty);
			const minValue = Math.min(...values);
			return minValue;
		} else {
			return false;
		}
	});

	//energy image
	let energyAttr = ref(null);
	if (props.item.attributes_special) {
		props.item.attributes_special.forEach(el => {
			if (el.attribute_code === 'ucinek-pranja-in-su-100218739') {
				energyAttr.value = el;
			}
			if (el.attribute_code === 'razred-energijske-u-100215480') {
				energyAttr.value = el;
			}
			if (el.attribute_code === 'razred-energijske-u-100176542') {
				energyAttr.value = el;
			}
			if (el.attribute_code === 'razred-energij-ucinkov-35') {
				energyAttr.value = el;
			}
		});
	}

	//recommended price
	const priceRecommended = computed(() => {
		if (
			props.item.selected_price == 'recommended' &&
			(props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) &&
			(!props.item.loyalty_price_custom || isLoyalty.value == false || (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.price_custom < props.item.loyalty_price_custom))
		) {
			return true;
		} else {
			return false;
		}
	});

	//badge discount
	const discountPercent = computed(() => {
		if (props.item.selected_price == 'recommended' && (props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) && (isLoyalty.value == true && props.item.loyalty_price_custom) && props.item.loyalty_price_custom < props.item.price_custom) {
			return Math.floor((1 - props.item.loyalty_price_custom / props.item.price_custom) * 100, 0);
		} else if ((isLoyalty.value == true && props.item.loyalty_price_custom) && props.item.price_custom > props.item.loyalty_price_custom) {
			return Math.floor((1 - props.item.loyalty_price_custom / props.item.basic_price_custom) * 100, 0);
		} else {
			return Math.floor(props.item?.discount_percent_custom);
		}
	});
	const priceSaved = computed(() => {
		if (props.item.selected_price == 'recommended' && (props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) && (isLoyalty.value == true && props.item.loyalty_price_custom) && props.item.loyalty_price_custom < props.item.price_custom) {
			return props.item.price_custom - props.item.loyalty_price_custom;
		} else if ((isLoyalty.value == true && props.item.loyalty_price_custom) && props.item.price_custom > props.item.loyalty_price_custom) {
			return props.item.basic_price_custom - props.item.loyalty_price_custom;
		} else {
			return props.item.basic_price_custom - props.item.price_custom;
		}
	});

	//conf items label
	const priceFrom = computed(() => {
		if (['advanced', 'configurable'].includes(props.item.type) && props.item.basic_price_custom > props.item.price_custom) {
			return true;
		} else {
			return false;
		}
	});

	//XXX verification
	let xxxVisibility = ref(props.item?.xxx);
	function hasCookie(cookieName) {
		if (typeof document !== 'undefined' && props.item?.xxx) {
			const cookies = document.cookie.split(';');
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].trim();
				if (cookie.startsWith(cookieName + '=')) {
					xxxVisibility.value = false;
					return true;
				} else {
					xxxVisibility.value = true;
				}
			}
		}
		return false;
	}

	onMounted(() => {
		hasCookie('xxx_verification');
	});

	watch(
		() => bus.value,
		() => {
			if(bus.value?.event == 'xxx_verificated') {
				hasCookie('xxx_verification');
				xxxVisibility.value = false;
			}
		}
	);

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	//gtm
	function gtmSelectItem(value) {
		let listTitle = '';
		let listCode = '';
		if(props.mode && props.mode == 'menu') {
			listTitle = 'megamenu - ' + props.categoryListData?.title;
			listCode = 'megamenu - ' + props.categoryListData?.code;
		} else if(props.mode && props.mode == 'publish') {
			listTitle = 'publish - ' + props.categoryListData?.title;
			listCode = 'publish - ' + props.categoryListData?.id;
		} else {
			listTitle = props.categoryListData?.title;
			listCode = props.categoryListData?.code;
		}
		const transformedData = {
			'list_title': listTitle,
			'list_code': listCode,
		};
		if(value) {
			gtm.selectItem([value], transformedData, props.index);
		}
	}

	//flyout order in progress info
	function flyoutOrderInProgressInfo() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		emit('flyoutUpdate', {'flyout_title': labels.get('order_in_creation_flyout_title'), 'flyout_content': labels.get('order_in_creation_flyout_content')});
	}

	//gtm
	async function addedToCart(value) {
		if(value?.status?.success) {
			const cart = await webshop.getCartData();
			let matchFound = false;

			cart?.parcels?.forEach(parcel => {
				if (matchFound) return;
				parcel?.items?.forEach(data => {
					if (matchFound) return;
					// Check if gtmData is not already assigned

					const matchedProduct = value?.products?.find(product => product?.shopping_cart_code === data?.shopping_cart_code);
					if (matchedProduct) {
						matchFound = true;
						gtm.addProduct({'product': data});
					}
				});
			});
		}
	}
</script>

<style lang="less" scoped>
	.cpf {
		display: flex;
		flex-direction: column;
		width: 100%;
		border: 1px solid @borderColor;
		background: @white;
		position: relative;
		.transition(all);
		@media (min-width: @t) {
			&:hover {
				border-color: @hoverBorderColor;
				z-index: 111;
				.cpf-badge-tooltip {
					visibility: visible;
					font-size: 11px;
					transform: translateX(0);
				}
			}
		}
	}
	.cpf-top {
		display: flex;
		flex-grow: 1;
		padding: 11px 20px 15px;

		@media (max-width: @m) {
			padding: 10px 20px 12px 10px;
		}
	}
	.cpf-image-container {
		width: 120px;
		height: 120px;
		margin-right: 20px;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		@media (max-width: @t) {
			width: 75px;
			height: 75px;
			margin-right: 15px;
		}
		@media (max-width: @m) {
			flex-direction: column;
			align-items: center;
		}
	}
	.cpf-image {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 120px;
		height: 120px;
		a {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 120px;
			height: 120px;
		}
		:deep(img) {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
			display: block;
		}

		&.xxx{
			:deep(a){
				filter: blur(10px); position: relative;
				&:before{.pseudo(auto,auto); top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.8); z-index: 1;}
			}
		}

		@media (max-width: @t){
			width: 75px;
			height: 75px;
			a {
				width: 75px;
				height: 75px;
			}
		}
		@media (max-width: @m) {
			align-items: flex-start;
			flex-grow: 1;
		}
	}

	.cpf-xxx-img-info{
		display: flex; justify-content: center; padding-top: 43px; font-size: 15px; font-weight: 600; color: @textColor; position: absolute; z-index: 1;
		&:before{.pseudo(36px,36px); display: flex; align-items: center; justify-content: center; background: url(assets/images/hide.svg); background-size: contain; position: absolute; top: 0;}

		@media (max-width: @m){
			padding-top: 33px; font-size: 13px;
			&:before{width: 30px; height: 30px;}
		}
	}
	.cpf-xxx-img-btn{
		display: flex; align-items: center; justify-content: center; height: 40px; margin: 0 30px; padding: 5px 25px; background: @white; border: 1px solid @borderColor; font-size: 13px; font-weight: 600; color: @textColor; position: absolute; left: 0; right: 0; bottom: 0; cursor: pointer; z-index: 1; .transition(all);
		&:hover{border-color: @red; color: @red;}
	}

	.cpf-badge {
		display: inline-flex;
		align-items: center;
		position: absolute;
		top: 4px;
		left: 0;
		font-size: 12px;
		line-height: 1.3;
		font-weight: 600;
		text-decoration: none;
		text-transform: uppercase;
		color: @white;
		z-index: 11;
		span {
			min-width: 50px;
			padding: 4px 7px;
			background: @blue;
			border: 1px solid @blue;
			text-align: center;
			flex-shrink: 0;
			position: relative;
			z-index: 1;
		}
		&:hover {
			color: @white;
			text-decoration: none;
		}

		@media (max-width: @t) {
			font-size: 11px;
			span {
				min-width: 45px;
				padding: 3px 5px;
			}
		}
		@media (max-width: @m) {
			top: 0;
		}
	}
	.cpf-badge-tooltip {
		padding: 5px 10px;
		flex-shrink: 0;
		background: @white;
		border: 1px solid @borderColor;
		border-left: 0;
		font-size: 0;
		text-transform: none;
		color: @textColor;
		position: relative;
		visibility: hidden;
		transform: translateX(-44px);
		transition: all 0.3s ease, font-size 1ms;
		&:before {
			.pseudo(6px,6px);
			left: -4px;
			top: 50%;
			background: @blue;
			transform: translateY(-50%) rotate(45deg);
		}

		@media (max-width: @t) {
			display: none !important;
		}
	}
	.cpf-badge-discount {
		span {
			border: 1px solid @red;
			background: @red;
		}
	}
	.cpf-badge-tooltip-discount:before {
		background: @red;
	}
	.cpf-badge-discount-loyalty {
		span {
			border-color: @blue;
			background: @blue;
		}
		.cpf-badge-tooltip:before {
			background: @blue;
		}
	}
	.cpf-energy {
		height: 20px;
		max-width: 80px;
		font-size: 13px;
		position: absolute;
		top: 92px;
		left: 0;
		:deep(img) {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
			display: block;
		}

		@media (max-width: @t) {
			height: 18px;
			max-width: 65px;
			font-size: 12px;
		}
		@media (max-width: @m) {
			position: relative;
			top: unset;
			left: unset;
		}
	}

	.cpf-cnt {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		padding-top: 10px;
		position: relative;

		@media (max-width: @m) {
			padding-top: 8px;
		}
	}
	.cpf-info {
		flex-grow: 1;
	}
	.cpf-code {
		display: none;
	}
	.cpf-cnt-comment {
		display: flex;
		align-items: flex-start;
		margin-top: 5px;
	}
	.cpf-category {
		font-size: 11px;
		line-height: 1.4;
		font-weight: 600;
		color: @blue;
		text-transform: uppercase;
		margin-bottom: 3px;
		&.blur{filter: blur(3px);}
		a {
			color: @blue;
			text-decoration: none;
			&:hover {
				color: @blue;
				text-decoration: underline;
			}
		}

		@media (max-width: @t) {
			a:hover {
				color: @blue;
				text-decoration: none;
			}
		}
		@media (max-width: @m) {
			display: none;
		}
	}
	.cpf-title {
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		font-size: 14px;
		line-height: 1.3;
		font-weight: normal;
		padding: 0;
		&.blur{filter: blur(4px);}
		a {
			color: @textColor;
			&:hover {
				color: @blue;
			}
		}

		@media (max-width: @t) {
			font-size: 13px;
			a:hover {
				color: @textColor;
			}
		}
	}
	.cpf-cnt-comment {
		display: flex;
		align-items: flex-start;
		margin-top: 5px;
	}
	.cpf-comment-count {
		margin-left: 4px;
		color: @textColor;
		font: 13px/1.2 @font;
		a {
			color: @textColor;
			text-decoration: none;
			@media (min-width: @t) {
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	.cpf-price {
		display: flex;
		align-items: flex-end;
		flex-wrap: wrap;
		margin-top: 10px;
		&.uau-badge .cpf-current-price:not(.blue) {
			color: #f57855;
		}

		@media (max-width: @m) {
			align-items: baseline;
		}
	}
	.cpf-loyalty-price {
		padding-left: 7px;
		font-size: 13px;
		line-height: 1.1;
		color: @blue;
		font-weight: 600;

		@media (max-width: @m) {
			width: auto;
			padding-left: 5px;
			font-size: 12px;
		}
	}
	.cpf-price-label {
		padding: 0 7px 0 0;

		@media (max-width: @m) {
			padding: 0 5px 0 0;
		}
	}
	.cpf-old-price {
		font-size: 13px;
		line-height: 1.1;
		padding-left: 7px;

		@media (max-width: @m) {
			font-size: 12px;
			padding-left: 5px;
		}
	}
	.cpf-current-price {
		font-size: 20px;
		line-height: 1.1;
		font-weight: 600;
		&.blue {
			color: @blue;
		}
		p {
			display: inline-block;
			font-size: 12px;
			line-height: 21px;
			font-weight: normal;
			margin-left: 5px;
			padding: 0;
			span {
				font-size: 14px;
				font-weight: 600;
			}
		}

		@media (max-width: @t) {
			font-size: 16px;
			p {
				display: block;
				margin: 3px 0 0;
			}
		}
		@media (max-width: @ms) {
			p {
				font-size: 10px;
				line-height: 19px;
				margin-top: 1px;
				span {
					font-size: 12px;
				}
			}
		}
	}

	.cpf-bottom {
		display: flex;
		align-items: center;
		padding: 9px 20px;
		border-top: 1px solid @borderColor;

		@media (max-width: @m) {
			display: none;
		}
	}
	.cpf-available-qty {
		flex-shrink: 0;
		flex-grow: 1;
		padding-right: 15px;
		font-size: 13px;
		line-height: 1.3;
		font-weight: 600;
		color: @lightGreen;
		span {
			display: block;
			padding-left: 22px;
			position: relative;
			&:before {
				.icon-available();
				font: 16px/16px @fonti;
				color: @lightGreen;
				position: absolute;
				left: 0;
			}
		}
		.available-last {
			color: @gray;
			&:before {
				.icon-available-last();
				font-size: 14px;
				line-height: 14px;
				color: @orange;
				top: 2px;
			}
		}
		.unavailable {
			color: @gray;
			padding: 0;
			&:before {
				content: none;
			}
		}

		@media (max-width: @m){display: none;}
	}
	.cpf-seller {
		font-size: 11px;
		line-height: 13px;
		.extra-name {
			margin-left: 3px;
			font-size: 11px;
			line-height: 13px;
			font-weight: normal;
			color: @inputTextColor;
		}
		a {
			font-weight: 600;
			color: @blue;
			text-decoration: underline;
			&:hover {
				text-decoration: none;
			}
		}
	}

	.cpf-btns {
		display: flex;
		align-items: flex-end;
		margin-left: 10px;
		z-index: 1;

		@media (max-width: @m) {
			display: none;
		}
	}
	.cpf-btn-addtocart {
		width: 44px;
		height: 44px !important;
		padding: 0;
		font-size: 0;
		line-height: 0;
		position: relative;
		cursor: pointer;
		.transition(opacity);
		&:before {
			.icon-cart();
			font: 19px/19px @fonti;
		}
		span {
			display: none;
		}
		&.details:before {
			.icon-info();
			font: 16px/16px @fonti;
			top: 3px;
		}
	}
	.cpf-btn-details {
		&:before {
			.icon-info();
			font: 16px/16px @fonti;
			top: 3px;
		}
	}
</style>
